import React from 'react'
import './loader.css'
const loader = () => {
    return (
        <div class="lds-roller">
            <div> </div>
            <div></div>
            <div></div>
            <div></div>
        </div>

    )
}

export default loader